import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack, useColorModeValue } from '@chakra-ui/react'
import { FaqQuestionForm } from '../../../../components/secure/dashboard/faq/FaqQuestionForm'
import { GetFaqQuestionQuery } from '../../../../api/queries/faq/FaqQueries'
import { history } from '../../../../ApplicationRouter'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'

export const EditFaqQuestion = () => {
  let { questionId } = useParams();
  const { t } = useTranslation();

  const { data } = useQuery(['faq/questions', questionId], () => GetFaqQuestionQuery(questionId!), { enabled: !!questionId });

  return (
    <AutoWidthCenter bg={useColorModeValue("bgTertiaryWhite", "bgPrimaryBlack")}>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">{t('Faq_Question.Edit')}</Heading>
          <Button onClick={() => history.back()}>{t('Return')}</Button>
        </HStack>
        <Divider />
        {data &&
          <FaqQuestionForm categoryId={data.categoryId} faqQuestion={data} />
        }
      </Box>
    </AutoWidthCenter >
  )
}